/*
From parent liquid file, this file receives:
  - productId: The Shopify product Id
  - totalOptions: Indicates the total number of Options
  - productOptionsJson: Is the list of options in JSON format
*/
var selectedOptions = [];
var productOptions;
var symbol="";
var changevalue = false;

$('[data-toggle="popover-option"]').popover();
$(document).ready(function () {
  
  
$(".accordion-button").click(function() {
  $(".accordion-collapse.collapse").collapse("hide");
});
  
  
$(".test-options").click(function() {
  
  var c = this.closest( "div.container-all-categories");
  var selected = c.getElementsByClassName("selected-img");
  if(selected.length > 0){
  	selected[0].classList.remove("selected-img");
  }
  this.parentNode.classList.add("selected-img");
  var event = new Event('change');
  // Dispatch it. radio button 
  this.children[0].dispatchEvent(event);
  
  
});

  
  
  
  
    //symbolCurrency
  loadSymbol(); 
  
  updatePrice();
  
  productOptions = productOptionsJson;
  
  // Open first option automatically
  // if(basePriceOptions.length > 0) {
  if(productOptions.length > 0) {
    
    var baseOption = productOptions.find(checkBasePrice);
    if(typeof baseOption === 'undefined'){
        $("#flush-collapse-"+productOptions[0].Id).collapse("show");
    }else {
      selectedOptions.push(baseOption.Options[0]);
      updatePrice();
      $("#flush-collapse-"+productOptions[0].Id).collapse("show");
    }
  }
  // else {
  //   if(addOnOptions.length > 0) {
  //     $("#flush-collapse-"+addOnOptions[0].Id).collapse("show");
  //   }
  //   else {
  //     if(simpleOptions.length> 0) {
  //       $("#flush-collapse-"+simpleOptions[0].Id).collapse("show");
  //     }
  //   }
  // }

  // When deselect is triggered, remove option from list
  $('input[type="radio"]').bind('deselect', function (event) {

    // Element id is composed of: rs-radio-{option id}-{subGroup id}
    var id = event.target.id.split("-")[2];

    // If option was selected, then refresh the selectedOptions array
    if (selectedOptions.find(o => o.Id === +id)) {
      selectedOptions = selectedOptions.filter(o => o.Id !== +id);
    }
  });

  // Attaching click event handlers to all radio buttons
  // $('input[type="radio"]').on('change', function () {
  //   // Bind deselect event to all other radios with the same name, except the one who changed
  //   $('input[name="' + $(this).attr('name') + '"]').not($(this)).trigger('deselect');
  // });
});

// Radio selector is by class since ID is different for each one
$('.rs-radio-input').on('change', function (event) {

  // Trigger deselect event to all other radios with the same name, except the one who changed
  $('input[name="' + $(this).attr('name') + '"]').not($(this)).trigger('deselect');
  
  // Element name composed of: rs-radio-{so.id}
  var targetNameSplit = event.target.name.split("-");
  
  // The primary group id
  var groupId = targetNameSplit[2];
  
  // Element id is composed of: rs-radio-{option id}-{subGroup id}
  var targetSplit = event.target.id.split("-");

  // The selected option id
  var optionId = targetSplit[2];
  
  //$("#flush-collapse-"+groupId).collapse("toggle");
  
  var bpo = basePriceOptions.find(bpo => bpo.Id == groupId);
  var aoo = addOnOptions.find(aoo => aoo.Id == groupId);
  var so = simpleOptions.find(so => so.Id == groupId);
  
  // if(bpo) {
  //   var ibpo = basePriceOptions.indexOf(bpo);
  //   var next = basePriceOptions[++ibpo]
  //   if(next) {
  //     $("#flush-collapse-"+next.Id).collapse("show");
  //   }
  //   else {
  //     if(addOnOptions.length > 0) {
  //       $("#flush-collapse-"+addOnOptions[0].Id).collapse("show");
  //     }
  //     else {
  //       if(simpleOptions.length > 0) {
  //         $("#flush-collapse-"+simpleOptions[0].Id).collapse("show");
  //       }
  //     }
  //   }
  // }
  
  // if(aoo) {
  //   var iaoo = addOnOptions.indexOf(aoo);
  //   var next = addOnOptions[++iaoo];
  //   if(next) {
  //     $("#flush-collapse-"+next.Id).collapse("show");
  //   }
  //   else {
  //     if(simpleOptions.length > 0) {
  //       $("#flush-collapse-"+simpleOptions[0].Id).collapse("show");
  //     }
  //   }
  // }
  
  // if(so) {
  //   var iso = simpleOptions.indexOf(so);
  //   var next = simpleOptions[++iso];
  //   if(next) {
  //     $("#flush-collapse-"+next.Id).collapse("show");
  //   }
  // }

    var co = productOptions.find(so => so.Id == groupId)
    var iso = productOptions.indexOf(co);
   

  // If option is already selected, then continue
  if(selectedOptions.find(o => o.Id === +optionId)) return;

  var radioOption = null;

  // If radio id has more than 3 sections, then is a sub group
  if (targetSplit.length > 3 && targetSplit[3] !== ""){
    var subGroupId = targetSplit[3];
    // Find the option inside the subgroup
    for (let i = 0; i < productOptions.length; i++) {
      

      var sg = productOptions[i].SubGroups?.find(sg => sg.Id === +subGroupId);
      if (!sg) continue;
      radioOption = sg.Options.find(o => o.Id === +optionId);
      if (radioOption) {
        radioOption.Price = sg.Price;
        break;
      }
    }
  } else {
    // Find the selected option
    for (let i = 0; i < productOptions.length; i++) {
      radioOption = productOptions[i].Options.find(o => o.Id === +optionId);
      if (radioOption) break;
    }
  }

  selectedOptions.push(radioOption);
  var totalPrice = updatePrice();
  // If all options where selected, then enable the button
  if(selectedOptions.length === +totalOptions) {
    if (totalPrice > 0) {
      $('#add-to-cart-button').prop('disabled', false);
    } else {
      $('#no-price-error').show();
    };
  }
});

$('#add-to-cart-button').on('click', function() {
  $('#add-to-cart-button').prop('disabled', true);
  $('#please-wait').show();
  $('#build-complete-div').hide();
  $('#button-spinner').show();
  var propertieList = [];
  for (i = 0; i < productOptions.length; i++)  {
    for(r = 0; r < selectedOptions.length; r++){
      if (productOptions[i].Options != null && productOptions[i].Options.find(e => e.Id === selectedOptions[r].Id) || productOptions[i].SubGroups != null && productOptions[i].SubGroups.find(g => g.Options.find(o => (o.Id === selectedOptions[r].Id) && (o.Name === selectedOptions[r].Name)  ))){
      	if (selectedOptions[r].Name != "Default"){
      		var propertie = {};
      		var subgroup = productOptions[i].SubGroups != null?  productOptions[i].SubGroups.find(g => g.Options.find(o => (o.Id === selectedOptions[r].Id) && (o.Name === selectedOptions[r].Name) )): null;
  				propertie.NameGroup = subgroup ? subgroup.Name : null;
      		propertie.Name =  productOptions[i].Name;
      		propertie.Photo = selectedOptions[r].HiResPhotos[0] != null ? selectedOptions[r].HiResPhotos[0] : selectedOptions[r].LowResPhotos[0] != null ? selectedOptions[r].LowResPhotos[0] : null;
      		propertie.Text  = selectedOptions[r].Name  ;
    			if(propertieList.length <1  || !propertieList.find(p=> p.Name == propertie.Name))propertieList.push(propertie);
      						}
      				}
      		}
      }
  // Make a request with all the selected options
  var payload = {
    price: $('#rs-builder-total').text(),
    optionIds: selectedOptions.map(so => so.Id),
    productId: productId
  };

  $.ajax({
    type: 'POST',
    url: 'https://api.retailsystem.io/variant/GetProductVarintId',
    data: JSON.stringify(payload),
    success: function (data) {
      var x  =  parseInt(window.localStorage.getItem('products_loading'));
      window.localStorage.setItem('products_loading', ++x);
      changevalue = true;
      // Add new variant to cart
        CartJS.addItem(data, 1, propertieList, {
        "success": function(data, textStatus, jqXHR) {
            var interval = setInterval(function(){
              if(changevalue){
                x  =  parseInt(window.localStorage.getItem('products_loading'));
                window.localStorage.setItem('products_loading', --x);
                changevalue = false;
              }
              $('#please-wait').hide();
              $('#cart-not-ready').show();
              CartJS.getCart().then(res => {
                if(res.items[0].title != null) {
                  $('#button-spinner').hide();
                  $('#cart-not-ready').hide();
                  $('#build-complete-div').show();
                  clearInterval(interval);
                }
              })
            }, 2000);
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + errorThrown + '!');
        }
      });
    },
    error: function (err) {
      alert('Product build failed.');
    },
    headers: { 'Content-Type': 'application/json' },
  });
});
function loadSymbol()
{
  if(symbolCurrency!=null){
    symbol= symbolCurrency.substr(1, 1);
  }
}

function updatePrice() {
  var total = 0.00;

  if (selectedOptions.length > 0) {
    selectedOptions.map(o => {
      if (o.Price) {
        total += o.Price;
      }
    });
  }
  $('#rs-builder-symbol').text(symbol);
  $('#rs-builder-total').text(total.toFixed(2));
  return total;
};

function checkBasePrice(productOption) {
  return productOption.Id == 0;
}


window.addEventListener('beforeunload', function (e) {
 if (changevalue){
  x  =  parseInt(window.localStorage.getItem('products_loading'));
  window.localStorage.setItem('products_loading', --x);
 }
});